export const dashInvoices = {
  invoices: {
    title: "Faturas a enviar",
    subtitle: "Aqui você verá as solicitações que aguardam a emissão da fatura.",
    loading: "Carregando…",
    empty: "Nenhuma fatura a enviar.",
    guestFallback: "Hóspede",
    manualBadge: "Manual",
    manualBadgeTitle: "Não gerada automaticamente: você a emite manualmente",
    manualCheckoutTitle: "Não gerada automaticamente: emita-a manualmente",
    linkSentTitle: "Link enviado ao hóspede",
    linkPendingTitle: "O link será enviado no dia do check-out",
    manualIssue: "Emissão manual",
    sendLinkTitle: "Envie ao hóspede o link para completar os dados da fatura",
    resend: "Reenviar",
    sendLink: "Enviar link",
    closeRequestTitle: "Fechar esta solicitação (você a emite manualmente)",
    close: "Fechar",
    cancelAutoTitle: "Cancelar o envio automático para enviá-la manualmente por outro meio",
    cancel: "Cancelar",
    viewAll: "Ver todas as faturas",
    confirmCancel: {
      title: "Cancelar o envio automático?",
      html: "O link da fatura não será enviado ao hóspede.<br>Você poderá enviá-lo manualmente por outro meio.",
      confirm: "Sim, cancelar",
      cancel: "Não",
    },
    confirmSend: {
      title: "Enviar o link da fatura?",
      html: "O link para completar os dados fiscais será enviado ao hóspede pelo WhatsApp.<br>Você emite a fatura manualmente.",
      confirm: "Sim, enviar",
      cancel: "Não",
    },
    cancelError: {
      title: "Não foi possível cancelar",
    },
    closeError: {
      title: "Não foi possível fechar",
    },
    sendError: {
      title: "Não foi possível enviar",
    },
    sendSuccess: {
      title: "Link enviado",
      text: "O hóspede recebeu o link da fatura.",
    },
    retry: "Tente novamente.",
  },
  balances: {
    title: "Saldos pendentes",
    subtitle: "Reservas com valor a pagar.",
    total: "Total",
    paid: "Pagamento processado",
    loading: "Carregando…",
    empty: "Nenhum saldo pendente.",
    emptySub: "Quando uma reserva tiver valor a pagar, aparecerá aqui.",
    viewAll: "Ver todos os saldos",
  },
  balancesDrawer: {
    title: "Saldos pendentes",
    close: "Fechar",
    from: "De",
    to: "Até",
    sort: "Ordenar",
    sortArrival: "Data de check-in",
    sortProximity: "Proximidade da chegada",
    searchPlaceholder: "Buscar acomodação…",
    allAccommodations: "Todas as acomodações",
    noResults: "Nenhum resultado",
    clear: "Limpar",
    totalPending: "Total pendente",
    ofTotal: "de {amount} {currency}",
    loading: "Carregando…",
    empty: "Nenhuma reserva com saldo pendente.",
    end: "Não há mais.",
    tags: {
      ended: "Estadia encerrada",
      now: "Hospedado",
      today: "Chega hoje",
      tomorrow: "Chega amanhã",
      dayAfter: "Chega em 2 dias",
    },
  },
};
